import { AbstractEntityTabLoader, } from '../../utils/component/abstract-entity-tab-loader/abstract-entity-tab.loader';
import { SequenceEntity } from '../sequence.entity';

export class SequenceTabLoader
  extends AbstractEntityTabLoader<SequenceEntity> {
  protected pageSize = 20;
  protected sort = 'name';
  protected searchFilterKey = 'filter[nameLike]';
}
